import bhau from "../assets/artists/bhau.png";
import mayank from '../assets/artists/mayank.png';
import shady from '../assets/artists/shady.png';
import bharath from '../assets/artists/bharath.png';
import vinayak from '../assets/artists/vinayak.png';
import raeyna from '../assets/artists/raeyna.png';
import jangidartist from '../assets/artists/jangid.png';
import sehgal from '../assets/artists/sehgal.png';
import manas from '../assets/artists/manas.png';
import shikhar from '../assets/artists/shikhar.png';
import amj from "../assets/artists/amj.jpeg";

import rythm from "../assets/accolades/rythm.jpeg"
import darya2 from "../assets/accolades/darya2.jpeg"
import anwesha from "../assets/accolades/anwesha.jpeg"
import duality from "../assets/accolades/duality.jpeg"
import aanuja from "../assets/accolades/aanuja.jpeg"
import choir from "../assets/accolades/choir.jpeg"
import darya from "../assets/accolades/darya.jpeg"
import sakshamb from "../assets/accolades/saskshamb.jpeg"
import amitoj from "../assets/accolades/amitoj.jpeg"
import harshit from "../assets/accolades/harshit.jpeg"
import vanshaj from "../assets/accolades/vanshaj.jpeg"
import duet from '../assets/accolades/duet.jpeg'
import lakshay from "../assets/accolades/lakshay.jpeg"
import sabya from "../assets/accolades/sabya.png";
import fourforty from "../assets/accolades/fourforty.png";
import dhoomketu from "../assets/accolades/dhoomketu.jpeg";
import acapella from '../assets/accolades/acapella.jpeg';
import apoorv from "../assets/accolades/apoorv.png";
import anasuya from "../assets/accolades/anasuya.png";
import jahnavi from "../assets/accolades/jahnavi.png";
import akarshita from '../assets/accolades/akarshita.png';
import saksham from '../assets/accolades/saksham.png';
import jangid from '../assets/accolades/jangid.png';
import jayant from '../assets/accolades/jayantsaksham.png';
import anubhav from '../assets/accolades/anubhav.png';
import sarthak from '../assets/accolades/sarthak.png';

export const artist = [
  {
    name: 'BHAU',
    tag: 'Artist, Producer, Guitarist, Educator',
    image: bhau,
    desc: "BHAU is an artist and music producer from Jammu, India, who is making waves in the modern Dogri music scene. He skillfully blends a range of genres, from Alternative R&B to Hip-Hop, Psychedelia, Soul, Funk, and Progressive Rock, to create a unique and diverse. His Dogri debut album, 'Aadataan,' was released in 2021 and demonstrated his growth and versatility as an artist and received commercial and critical acclaim all over the world. In the present, BHAU is collaborating with talented artists such as  DilliVerse and Bharath and has also produced a track for Yo Yo Honey Singh . He also consistently puts out creatively mellifluous guitar covers on Instagram and also provides online guitar lessons.",
    spotifyEmbed: "https://open.spotify.com/embed/track/79V71JqmNlpAo1ASRVRAeN?utm_source=generator",
    ig: "https://www.instagram.com/rsbhau/",
    yt: "https://www.youtube.com/channel/UCSXv4zmSl8iCkgVrxQ9P7hw",
    spotify: "https://open.spotify.com/artist/74lKy2401dGEdFaTudLL7q?si=YRf9O_8sT-C8RKzM2SV91w",
  },

  {
    name: 'Mayank Mittal',
    tag: 'Artist, Vocalist, Educator',
    image: mayank,
    desc: 'Mayank Mittal AKA Eternalramblings is a paradoxical circus in a library – a fusion of a chaotic artistic soul and curious scientific mind. He seeks to combine rollercoaster emotions and a carousal of uncanny observations with insightful song writing, to tell you stories that fill an emotional vacuum and make you ponder.\n\nMittal is a part of the powerhouse pop-rock band KAPOW! and has already released a multitude of songs with the band in English and Hindi. He is famous for his on-stage charisma and euphonious voice. He has also collaborated with other reputed acts such as the Anirudh Varma Collective and Parikrama.',
    spotifyEmbed: 'https://open.spotify.com/embed/track/67BI0P4OK8KbIpIEaA7xE1?utm_source=generator',
    ig: "https://www.instagram.com/eternalramblings/",
    yt: "https://www.youtube.com/channel/UCJJaOgYaFZUHDGsUTj3oh3g",
    spotify: "https://open.spotify.com/artist/6wcAvk3vwdgF03WziIJa6H",
  },
  {
    name: 'The Shady Kid',
    tag: 'Artist, Vocalist, Educator',
    image: shady,
    desc: 'Suhail Zubair, popularly known as The Shady Kid, has carved out a distinct presence in the music realm since his college graduation in 2018. His debut single "2999," a collaboration with BHAU in 2020, marked his arrival with its unique sound and concept. He released his first album "Through My Lens" in 2022, showcasing his versatility and storytelling prowess. Alongside his music career, Zubair shares his expertise as a trained vocalist through personalized one-on-one lessons and workshops, nurturing aspiring talents. With a blend of talent, dedication, and innovation, The Shady Kid continues to make waves, promising an exciting future in music.',
    spotifyEmbed: "https://open.spotify.com/embed/track/2CpMRGyLiNTWouMn8NkFrA?utm_source=generator",
    ig: "https://www.instagram.com/the.shadykid/",
    yt: "https://www.youtube.com/@theshadykid3630",
    spotify: "https://open.spotify.com/artist/3WcnRsFrr0t4bZiE2W1TW2",
  },
  {
    name: 'Bharath',
    tag: 'Artist, Producer',
    image: bharath,
    desc: 'Bharath Rajeevan is a multi-genre artist, music producer, composer, songwriter and bassist. One of the most talented musicians to come out of Madhurima, Bharath has had a diverse range of experience as a musician. He has played bass for bands like "Above the Shadows" and "Kapow", produced countless musicians and also helped artists with their live sound. He was one of the founding members of the band "Kapow" and also shaped their sound through his songwriting and composing skills. Currently he is making waves in the independent music scene of India collaborating with artists such as SHAHI, Samad Khan, Heer, BHAU and Raeyna.',
    spotifyEmbed: "https://open.spotify.com/embed/track/3sLVQHa6ivHL6eXO2N5NTw?utm_source=generator",
    ig: "https://www.instagram.com/bharath.mp3/",
    yt: "",
    spotify: "https://open.spotify.com/artist/1zD9gVg8wPOmVfYxTjMHaT",
  },
  {
    name: 'Vinayak Arora',
    tag: 'Artist, Producer',
    image: vinayak,
    desc: 'Vinayak Arora is a full fledged musician who can play multiple instruments, sing a vast range of genres and create magic with his creative production. During his time in Madhurima, Vinayak won countless solo competitions and led the A Capella group to many victories. Vinayak started singing at the age of six when his first teacher Usha Mankotia taught him his first song. Vinayak has also trained in Vocals under Shri. Sudhanshu Bahuguna. He has released three singles  "Aadmi Bann Zara", "F*ck You", "Fuzzy Cuddly Scrampadoodlicious" and "Khumaar" all of which show his talent and range as a musician. He has also produced/mixed bands like Antariksh.',
    spotifyEmbed: "https://open.spotify.com/embed/track/2pZwlQWIfXTNZaNU5SRpOX?utm_source=generator",
    ig: "https://www.instagram.com/vinayak.arora/",
    yt: "https://www.youtube.com/@VinayakArora",
    spotify: "https://open.spotify.com/artist/2d41d3oOduJwmwKWjl15RZ",
  },
  {
    name: 'Raeyna',
    tag: 'Artist, Producer',
    image: raeyna,
    desc: 'Raeyna is an artist who sings to make you cry. The artist’s name comes from the latin word “Regina” meaning Queen which is a sign of royalty and therefore, highlights a certain sense of detachment from the rest of the population. It is symbolic of the inability of expressing oneself in traditional human notions and thus, using different artistic avenues to communicate. It represents a metaphor: a way of looking into our lives and answering the question of who we truly are and our outward life and choices as a definition of our rather closeted inner self. A fluent writer in both Hindi and English, he wishes to transform the Indie Music Industry with his fresh perspective on Indian Pop, RnB, and Hip-Hop music and hopes to work with artists internationally.',
    spotifyEmbed: "https://open.spotify.com/embed/track/4Yn8DHwYgXKbNXsG3rJDeM?utm_source=generator",
    ig: "https://www.instagram.com/raeyna/",
    yt: "https://www.youtube.com/@raeyna1016",
    spotify: "https://open.spotify.com/artist/4cSuJFjNwzW29ciFECV2dg",
  },
  {
    name: 'Abhishek Vijay',
    tag: 'Artist',
    image: jangidartist,
    desc: 'Abhishek Vijay, a boundary-breaking artist renowned for his debut single "Khumaar". Abhishek has carved a niche for himself with a distinctive fusion that seamlessly blends the timeless traditions of Hindustani classical with the contemporary vibes of electronic, rock, and classical elements. While not professionally trained, Abhishek’s journey began in childhood, when his natural inclination towards melody and composition became evident. His musical prowess reached new heights during his tenure as the president of Madhurima, a pivotal role where he orchestrated the formation of a band that went on to clinch numerous victories in competitions. Currently crafting a funk ghazal, he continues to redefine the boundaries of fusion music.',
    spotifyEmbed: "https://open.spotify.com/embed/track/6Bzjz8l59MJUPMW1doUGMu?utm_source=generator",
    ig: "https://www.instagram.com/abhishek.vijay_/",
    yt: "https://www.youtube.com/channel/UCknezJETXI_jKBitZ7QSFjA",
    spotify: "https://open.spotify.com/artist/2AAa9sPJ3QCEFxv0vwhFfs",
  },
  {
    name: 'Saksham Sehgal',
    tag: 'Artist',
    image: sehgal,
    desc: 'Capturing the hearts of listeners worldwide, Saksham Sehgal boasts a unique and versatile voice. His debut single ‘Baaki’ released in 2021 and received love from all parts of the country. His next single  ‘Sirf Tujhse’ showed his brilliance as a songwriter and achieved widespread critical and commercial acclaim. His songs have gained popularity in the indie- music scene through the word of mouth of his listeners, and have more than 500k combined streams. Post the success of ‘Sirf Tujhse’ he has released official merchandise for his songs and announced the release of his third and latest single ‘Guldaste’ which will release on 25th of February.',
    spotifyEmbed: "https://open.spotify.com/embed/track/5zICn0hbsUvZBpHeffRQcj?utm_source=generator",
    ig: "https://www.instagram.com/sakshamsehgal43/",
    yt: "https://www.youtube.com/channel/UCwofb-HVmF7g1siXPWsbDoQ",
    spotify: "https://open.spotify.com/artist/12P49nEzmoKmsmYuI8edpW",
  },
  {
    name: 'Manas Swarnkar',
    tag: 'Artist, Producer',
    image: manas,
    desc: 'Manas Swarnkar is a multi-instrumentalist, music producer and songwriter. He has been making music since he was 16 years old, and has released his long-awaited EP "Rahguzar" during the summer of 2023.\n\nManas has always been found chasing sounds that invoke very specific feelings, and is not afraid to experiment to meet his artistic vision. Manas is inspired by many others in this list and owes a lot of gratitude to the ones that came before him. <3',
    spotifyEmbed: "https://open.spotify.com/embed/track/0RXgfgB2XEl6oBB5HpQFvj?utm_source=generator",
    ig: "https://www.instagram.com/manas_swarnkar/",
    yt: "https://www.youtube.com/channel/UCoGJdOE3TtNBDs6fg9ypbFg",
    spotify: "https://open.spotify.com/artist/1g3a4yCY2rjZY8fq5YqCHy",
  },
  {
    name: 'Shikhar Agarwal',
    tag: 'Flautist',
    image: shikhar,
    desc: 'Shikhar Agarwal is a Flautist who has trained under Shri. Kailash Sharma since he was 10 years old. He has been performing on stage, radio and TV recording as a soloist, in orchestras, band collaborations since childhood. Shikhar graduated in 2018 and left his job to pursue music as a full time career. He has played along with a diverse range of groups ranging from alt-rock bands to solo classical events.\nShikhar is currently part of ‘the Taqdeer Collective’, a group which brings out their own renditions of classic tunes, and have been touring and performing gigs all across India.',
    spotifyEmbed: "",
    ig: "https://www.instagram.com/shikhar_flute/",
    yt: "https://www.youtube.com/@taqdeermusic",
    spotify: "",
  },
      {
    name: 'Aniruddha Majumdar',
    tag: 'Artist, Producer',
    image: amj,
    desc :'Aniruddha Majumdar is a Singer-Songwriter, Multi-Instrumentalist and Producer based in Delhi, India. He started releasing original music in 2025, each track recorded in his bedroom and self produced. He tries to bring in different parts of his inspirations to light, blending genres like Pop Rock, Midwest Emo, Shoegaze, Progressive Rock and Modern Metal. He is also the bassist and one of the core members of the Indo-Fusion band Darya, and currently serves as the Western Head of Madhurima.',
    spotifyEmbed: "https://open.spotify.com/embed/track/5P2hbWfUuauA88zB0RYHds?utm_source=generator",
    ig: "https://www.instagram.com/invictus.arpeggi?igsh=eDN5YTlrMjEzNXhr",
    yt: "https://www.youtube.com/channel/UCJiD8Z-X2DBBS2K3GaPeSLQ",
    spotify: "https://open.spotify.com/artist/4a4ZMXOgWgfWBYIHJVerGw?si=S5iReRWeQCSOgWi77wgy_Q",
  }


];

export const westernSolos = [
  {
    image: apoorv,
    name: 'Apoorv',
    tag: 'B. Tech. (CE)',
    wins: [
  "1st - Sri Aurobindo College",
  "1st - Ramjas College",
  "1st - PGDAV College",
  "1st - Gargi College",
  "1st - CVS",
  "1st - JMC",
  "1st - Hansraj College",
  "2nd - Swami Shraddhanand",
  "3rd - SSCBS",
  "3rd - IIT Delhi"
]

  },
  {
    image: aanuja,
    name: 'Aanuja Singh',
    tag: 'B. Tech. (ME)',
    wins: ["1st - IIT Bombay", "Golden Ticket - IIT Bombay"]},


]

export const indianSolos = [
  {
    image: vanshaj  ,
    name: 'Vanshaj',
    tag: 'B. Tech. (EE)',
    wins: ["2nd - Dyal Singh College"]
  },
  {
    image: lakshay,
    name: 'Lakshay Juyal',
    tag: 'BTech (BT)',
    wins: ["3rd - IIT Bombay","Golden Ticket - IIT Bombay"]
  },
  {
    image: rythm,
    name: 'Rythm Sachdeva',
    tag: 'B. Tech. (ECE)',
    wins: ["1st - IIT Bombay","Golden Ticket - IIT Bombay"]
  },
    {
    image: harshit,
    name: 'Harshit Singh',
    tag: 'B. Tech. (ECE)',
    wins: ["2nd - Sri Guru Gobind Singh College"]
  },
]

export const instrumental = [
  {
    image: amitoj,
    name: 'Amitoj Singh',
    tag: 'B. Tech. (ECE)',
    wins: ["1st - Bennet University",
       "1st - SRM University",
        "1st - ARSD College",
        "1st - IIIT Delhi",
      "1st - Sri Guru Gobind Singh College",
      "2nd - Acharya Narendra Dev College",
    "2nd - Sri Aurobindo College"]
  },
    {
    image: anwesha,
    name: 'Awnesha Mandal',
    tag: 'B. Tech. (ECE)',
    wins: ["1st - IIT Bombay",
       "1st - Lady Sri Ram College",
      "2nd - Deshbandhu College",
    "2nd - Sri Aurobindo College",
  "2nd - Sri Guru Gobind Singh College",]
  },
]


export const beatbox = [
    {
    image: sakshamb,
    name: 'Saksham Bisht',
    tag: 'Btech',
    wins: ["2nd - IIT Delhi"]
  },
]

export const Instrumental_Duet = [
    {
    image: amitoj,
    name: 'Amitoj Singh',
    tag: 'Btech (ECE)',
    wins: ["1st - NSUT"]
  },
]

export const Western_Duet = [
    {
    image: duet ,
    name: 'Vasavi Taneja & Aniruddha Majumdar',
    tag: 'Btech (SE)',
    wins: ["1st - Lady Hardinge Medical College"]
  },
]
export const band = [
  {
    image: dhoomketu,
    name: 'Dhoomketu',
    tag: 'Senior Band',
    wins: ["1st - IIT Bombay","1st - Maulana Azad Medical College",
      "1st - Dr. Baba Saheb Ambedkar College",
    "1st - Masters Union School of Business",
  "3rd - Bennet University"]
  },
  {
    image: darya2,
    name: 'Darya',
    tag: 'Junior Band',
    wins: ["1st - MDI Gurgaon",
            "1st - NDIM College",
            "1st - Motilal Nehru College",
            "1st - Aryabhatta College",
            "2nd - Sri Guru Gobind Singh College",
            "2nd - MLNC College",
            "2nd - Maharaja Surajmal Institute",
            "3rd - IIT Bombay",
            "3rd - Masters Union School of Business"
    ]
  },
    {
    image: duality,
    name: 'Duality',
    tag: 'Junior Band',
    wins: [
            "2nd - International Management Institute",
            "2nd - St. Stephens College",
    ]
  },
]

export const group = [
  {
    image: acapella,
    name: 'Acapella',
    tag: '',
    wins: [""]
  },
  {
    image: choir,
    name: 'Indian Choir',
    tag: '',
    wins: [""]
  },
]